export default {
  "Cut Audio": "Sesi Kes",
  "HitPaw Online Audio Cutter": "HitPaw Çevrimiçi Ses Kesici",
  "Trim or cut any audio files online.": "Herhangi bir ses dosyasını çevrimiçi olarak kırpın veya kesin.",
  "Cut": "Kes",
  "Fade in": "Açılma",
  "Fade out": "Karartma",
  "Cut from": "'ten kes",
  "to": "'e",
  "Extract selection": "Seçimi çıkar",
  "Delete selection": "Seçimi sil",
  "Adjust New": "Yeni Ayarla",
  "Cut New": "Yeni Kes",
  "Adjust Volume": "Ses Seviyesini Ayarla",
  "HitPaw Online Volume Changer": "HitPaw Çevrimiçi Ses Değiştirici",
  "Turn up or Turn down the volume of audio.": "Sesin seviyesini yükseltin veya kısın.",
  "Volume": "Ses Seviyesi",
  "Change Speed": "Hızı Değiştir",
  "HitPaw Online Audio Speed Changer": "HitPaw Çevrimiçi Ses Hızı Değiştirici",
  "Speed up or slow down audios online easily.": "Sesleri çevrimiçi ortamda kolayca hızlandırın veya yavaşlatın.",
  "Speed": "Hız",
  "Format": "Biçim",
  "Size": "Boyut",
  "Duration": "Süre",
};
